import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import AppInformation from './AppInformation';
import GeneralSettings from './GeneralSettings';
import LanguageSetting from './LanguageSetting';
import SMTPSettings from './SMTPSettings';
import { FONT_FAMILY } from "../common/sharedFunctions";
import CancellationReasons from './CancellationReasons';

const modernColors = {
  primary: '#4F46E5',
  primaryLight: '#818CF8',
  primaryDark: '#3730A3',
  secondary: '#10B981',
  background: '#F9FAFB',
  surface: '#FFFFFF',
  textPrimary: '#111827',
  textSecondary: '#6B7280',
  divider: '#E5E7EB',
  hover: '#F3F4F6',
  active: '#EEF2FF',
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 2, md: 3 }, mt: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Settings() {
  const [value, setValue] = React.useState(0);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ 
      width: '100%', 
      p: { xs: 1, md: 2 }, 
      backgroundColor: modernColors.background,
      minHeight: 'calc(100vh - 64px)'
    }}>
      <Paper elevation={2} sx={{ borderRadius: '12px', overflow: 'hidden', backgroundColor: modernColors.surface }}>
         <Typography 
            variant="h4" 
            sx={{ 
              p: 3, 
              fontWeight: 700, 
              color: modernColors.textPrimary, 
              fontFamily: FONT_FAMILY, 
              borderBottom: `1px solid ${modernColors.divider}`,
              backgroundColor: modernColors.surface
            }}
         >
            {t('settings_title')}
         </Typography>
        <Box sx={{ borderBottom: 1, borderColor: modernColors.divider }}>
          <Tabs 
            value={value} 
            onChange={handleChange} 
            aria-label="settings tabs" 
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              backgroundColor: modernColors.surface,
              borderBottom: `1px solid ${modernColors.divider}`,
              '& .MuiTabs-indicator': {
                backgroundColor: modernColors.primary,
                height: '3px',
                borderRadius: '3px 3px 0 0'
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.95rem',
                fontFamily: FONT_FAMILY,
                color: modernColors.textSecondary,
                py: 1.5,
                px: 2.5,
                opacity: 0.8,
                '&:hover': {
                  backgroundColor: modernColors.hover,
                  opacity: 1,
                },
                '&.Mui-selected': {
                  color: modernColors.primary,
                  fontWeight: 600,
                  opacity: 1,
                }
              }
            }}
          >
            <Tab label={t('app_info')} {...a11yProps(0)} />
            <Tab label={t('general_settings')} {...a11yProps(1)} />
            <Tab label={t('language')} {...a11yProps(2)} />
            <Tab label={t('smtp')} {...a11yProps(3)} />
            <Tab label={t('cancellation_reasons_title')} {...a11yProps(4)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <AppInformation/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <GeneralSettings/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <LanguageSetting/>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SMTPSettings/>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <CancellationReasons/>
        </TabPanel>
      </Paper>
    </Box>
  );
}